<template>
  <div class="admin-container" :class="{ mobile: isMobile || isTablet }">
    <div class="menu">
      <Dropdown openOnHover :options="options" v-model="selected">
        <Button type="outlined">Menu</Button>
      </Dropdown>
    </div>
    <slot></slot>
    <Footer v-if="!isMobile && !isTablet" />
    <MobileFooter v-else />
  </div>
</template>

<script lang="ts">
import Footer from "@/components/layout/Footer.vue"
import MobileFooter from "@/components/layout/MobileFooter.vue"
import Button from "@/components/uikit/Button.vue"
import Dropdown, { DropdownOption } from "@/components/uikit/Dropdown.vue"
import { useWindowSize } from "@/composables/useWindowSize"
import { defineComponent } from "vue"

export default defineComponent({
  name: "AdminLayout",
  components: { Dropdown, Button, Footer, MobileFooter },
  setup() {
    const { isMobile, isTablet } = useWindowSize()

    return { isMobile, isTablet }
  },
  data() {
    return {
      options: [
        {
          label: "Home",
          key: "admin.home",
          onClick: () => {
            this.$router.push({ name: "home" })
          },
        },
        {
          label: "Leaderboard",
          key: "admin.leaderboard",
          onClick: () => {
            this.$router.push({ name: "admin.leaderboard" })
          },
        },
        {
          label: "MM2 Items",
          key: "admin.mm2-items",
          onClick: () => {
            this.$router.push({ name: "admin.mm2-items" })
          },
        },
        {
          label: "Server Inventory",
          key: "admin.server-inventory",
          onClick: () => {
            this.$router.push({ name: "admin.server-inventory" })
          },
        },
        {
          label: "Ban Words",
          key: "admin.ban-words",
          onClick: () => {
            this.$router.push({ name: "admin.ban-words" })
          },
        },
        {
          label: "System Broadcasts",
          key: "admin.system-broadcasts",
          onClick: () => {
            this.$router.push({ name: "admin.system-broadcasts" })
          },
        },
        {
          label: "Moderators",
          key: "admin.moderators",
          onClick: () => {
            this.$router.push({ name: "admin.moderators" })
          },
        },
        {
          label: "Banned Users",
          key: "admin.banned-users",
          onClick: () => {
            this.$router.push({ name: "admin.banned-users" })
          },
        },
        // {
        //   label: "Bot Management",
        //   key: "admin.bot-management",
        //   onClick: () => {
        //     this.$router.push({ name: "admin.bot-management" })
        //   },
        // },
      ] as DropdownOption[],
      selected: this.$route.name as string,
    }
  },
  // mounted() {
  //   const routeName = this.$route.name
  //   if (routeName === "admin.leaderboard") {
  //     this.selected = "leaderboard"
  //   } else if (routeName === "admin.mm2-items") {
  //     this.selected = "mm2-items"
  //   }
  // },
})
</script>
<style lang="scss" scoped>
.admin-container {
  display: flex;
  justify-content: center;
  padding: 40px;

  &.mobile {
    margin-top: 1rem;
    padding: 40px 0;

    .menu {
      position: absolute;
      top: 0;
      right: 10px;
    }
  }

  .menu {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}
</style>
